import * as types from '../actions/action-types';

export function popup(state = {show: false, type: null, data: {}}, action) {

  switch (action.type) {
    case types.POPUP_SHOW:
      return {...state, show: true, type: action.popupType, data: action.data};

    case types.POPUP_HIDE:
      return {...state, show: false, type: null, data: action.data};

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./reducers/popup.js